import { useState, useCallback } from 'react';
import axios from 'axios';
import { isFunction } from 'lodash-es';

const sendForm = async (method, url, data) => axios({
  headers: { Accept: 'application/json, text/javascript' },
  responseType: 'json',
  data,
  method,
  url,
});

const useSubmitForm = ({
  formUrl,
  objectId,
  buildFormParams,
  handleError,
  beforeSubmitForm = null,
  afterSuccessSubmitForm,
}) => {
  const [isFormSending, setIsFormSending] = useState(false);

  const handleSubmitForm = useCallback(async (formData) => {
    if (isFunction(beforeSubmitForm)) beforeSubmitForm();
    setIsFormSending(true);

    const method = objectId ? 'patch' : 'post';
    const params = buildFormParams(formData);

    try {
      const response = await sendForm(method, formUrl, params);
      afterSuccessSubmitForm(response);
    } catch (error) {
      handleError(error);
    } finally {
      setIsFormSending(false);
    }
  }, [
    afterSuccessSubmitForm,
    objectId,
    formUrl,
    buildFormParams,
    handleError,
    beforeSubmitForm,
  ]);

  return { handleSubmitForm, isFormSending };
};

export default useSubmitForm;
